import { EditOtherDistributionModal } from 'components/EditOtherDistributionModal';
import { useMethodsConfirmationDialog } from 'hooks/useMethodsConfirmationDialog';
import { tabItemsDistribution } from 'pages/Project/Common/types';

import { useCallback, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import { useEditWorkOrderChangeOtherDistribution } from './useEditWorkOrderChangeOtherDistribution';

export const EditWorkOrderChangeOtherDistribution = ({
    workOrderChangeId,
    workOrderChangeOtherPriceId,
    workOrderOtherPriceId,
    currentConstructionTypeId,
    closeEditHandler,
    refreshOtherTableHandler,
    costRounding,
    defaultObjectCompositeId,
}: {
    workOrderChangeId: number;
    currentConstructionTypeId: number;
    workOrderChangeOtherPriceId: number | null;
    workOrderOtherPriceId: number | null;
    closeEditHandler: () => void;
    refreshOtherTableHandler: () => void;
    costRounding: number;
    defaultObjectCompositeId: string;
}) => {
    const {
        control,
        reset,
        handleSubmit,
        setError,
        setValue,
        watch,
        clearErrors,
        formState: { errors, isDirty },
    } = useForm();
    const [activeTab, setActiveTab] = useState(tabItemsDistribution[0]);

    const allFormValues = watch();

    const handleTabChange = useCallback(({ value }) => setActiveTab(value), [setActiveTab]);

    const handleSubmitWarningDialog = useCallback(() => {
        closeEditHandler?.();
    }, [closeEditHandler]);

    const { isOpenConfirmationDialog, handleOpenConfirmationDialog, handleCloseConfirmationDialog, handleActionQuery } =
        useMethodsConfirmationDialog({
            actionFn: handleSubmitWarningDialog,
        });

    const {
        isDataFetching,
        commonDistributionData,
        isCalculating,
        handleCancel,
        onSubmit,
        limitsDistributionData,
        linkedSeasonDistributionsData,
        isWorkOrderCostUpdating,
    } = useEditWorkOrderChangeOtherDistribution({
        workOrderChangeId,
        workOrderChangeOtherPriceId,
        workOrderOtherPriceId,
        reset,
        setError,
        errors,
        allFormValues,
        closeEditHandler,
        setActiveTab,
        refreshOtherTableHandler,
        handleOpenConfirmationDialog,
        clearErrors,
        isDirty,
        defaultObjectCompositeId,
    });

    const workOrderChangeCompositeIds = useMemo(
        () => `${workOrderChangeId}_${workOrderOtherPriceId}_${workOrderChangeOtherPriceId}`,
        [workOrderChangeId, workOrderChangeOtherPriceId, workOrderOtherPriceId],
    );

    return (
        <EditOtherDistributionModal
            handleCancel={handleCancel}
            onSubmit={onSubmit}
            isLoading={isWorkOrderCostUpdating}
            activeTab={activeTab}
            handleTabChange={handleTabChange}
            isDataFetching={isDataFetching}
            isCalculating={isCalculating}
            workOrderCommonData={commonDistributionData}
            currentConstructionTypeId={currentConstructionTypeId}
            workOrderLimitsData={limitsDistributionData}
            isOpenWarningDialog={isOpenConfirmationDialog}
            handleSubmitWarningDialog={handleActionQuery}
            handleCancelWarningDialog={handleCloseConfirmationDialog}
            formControl={control}
            formHandleSubmit={handleSubmit}
            setValue={setValue}
            isWorkOrderChange
            uerWorkOrderOtherDistributionData={linkedSeasonDistributionsData}
            workOrderChangeCompositeIds={workOrderChangeCompositeIds}
            costRounding={costRounding}
            watch={watch}
        />
    );
};

EditWorkOrderChangeOtherDistribution.displayName = 'EditWorkOrderChangeOtherDistribution';
